import { ESdChangeReason, LeftPanelType } from "@kuika/kuika-cl-model";
import { IWithSDProps, withSD } from "../../../shared/hoc/screen-design-consumer";
import { PureSdComponent } from "../../../shared/pure-sd";
import KuikaButton from "../../ui-kit/kuika-button/kuika-button";
import KuikaDropdownMenu from "../../ui-kit/kuika-dropdown-menu/kuika-dropdown-menu";
import KuikaSvg from "../../ui-kit/kuika-svg/kuika-svg";

export interface IAcademyButtonState {}

export interface IAcademyButtonProps {
  onMenuItemClick?: (panelType: LeftPanelType) => void;
}

class AcademyButton extends PureSdComponent<IAcademyButtonProps & IWithSDProps, IAcademyButtonState> {
  constructor(props: IAcademyButtonProps & IWithSDProps) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <>
        <KuikaDropdownMenu
          options={[
            {
              label: "Video Courses",
              icon: (
                <KuikaSvg
                  data-testid="videoCoursesButton"
                  data-onboarding-id="left_menu_academy_video-courses"
                  name="player-play"
                />
              ),
              onClick: () => {
                window.open("https://academy.kuika.com/en/courses", "_blank");
              }
            },
            {
              label: "User Guides",
              icon: (
                <KuikaSvg
                  data-testid="userGuidesButton"
                  data-onboarding-id="left_menu_academy_user-guides"
                  name="info-circle"
                />
              ),
              onClick: () => {
                window.open("https://academy.kuika.com/en/user-manual", "_blank");
              }
            },
            {
              label: "Tutorials",
              icon: (
                <KuikaSvg
                  data-testid="tutorialsButton"
                  data-onboarding-id="left_menu_academy_tutorials"
                  name="book"
                  type="sidebar-icons"
                />
              ),
              onClick: () => {
                window.open("https://academy.kuika.com/en/tutorials", "_blank");
              }
            }
          ]}
          trigger="hover"
          placement="topRight"
          offset={[32, -36]}
        >
          {(open) => (
            <KuikaButton
              data-testid="leftMenuAcademyButton"
              data-onboarding-id="left_menu_academy"
              type="tertiary"
              size="md"
              isIcon
              color="neutral"
              active={open}
              className="kuika-left-menu__academy-button kuika-tutorials-button"
            >
              <KuikaSvg
                name="notebook"
                type="sidebar-icons"
                width={18}
                height={18}
                className="kuika-tutorials-button-icon"
              />
            </KuikaButton>
          )}
        </KuikaDropdownMenu>
      </>
    );
  }

  checkNeedRender = (changeReason: ESdChangeReason): boolean => {
    return false;
  };
}

const academyButton = withSD<IAcademyButtonProps>(AcademyButton);
export { academyButton as AcademyButton };
